import moment from "moment";
import {
  CreditCardPaymentAccountType,
  PaymentMethodType
} from "../../types/airgraft";

export function getAvailableDefaultPayment(
  paymentMethods: PaymentMethodType[]
): PaymentMethodType {
  const defaultPaymentMethod = paymentMethods.find(p => p.defaultMethod);
  if (!defaultPaymentMethod) return null;

  if (
    defaultPaymentMethod.paymentType === "CREDIT" &&
    isCreditCardPaymentMethodExpired(defaultPaymentMethod.paymentMethod)
  ) {
    return null;
  } else {
    return defaultPaymentMethod;
  }
}

export function isCreditCardPaymentMethodExpired(
  paymentMethod: CreditCardPaymentAccountType
) {
  return moment(paymentMethod.cardExpirationDate, "MM/YY")
    .add(1, "M")
    .subtract(1, "day")
    .isBefore(moment());
}
